/* eslint-disable no-unused-expressions */

/******************************************************************************
 * Sys Class
 * version: 1.0.1, release: 07.09.2018
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

// import { config, key } from 'localforage';
import React from 'react';
import DateFormat  from './DateFormat';
import { ObjectUtil } from './ObjectUtil';
import './SystemUtils.scss';
import { createPortal } from 'react-dom';

const exec = window.require?.('child_process').exec;
const os = window.require?.('os');

let urlVars;

const secondsToTime = c => {
	let h = Math.floor( c / 3600);
	let m = Math.floor((c - (h * 3600)) / 60);
	let s = Math.floor(c - (h * 3600) - (m * 60));
	return h + ':' + (m < 10? '0'+m : m) + ':' + (s < 10? '0'+s : s);
}

//============================================================================= Sys Class
export default class Sys {
	static storageProvider = localStorage;		//can changed optional with e.g. localForage

	// static status = props => {
	// 	const container = document.getElementById('root');
	// 	console.log('create portal for status ...')
	// 	createPortal(<div className='app-portal'>ROOT</div>, document.body)
	// }


	static loadImages = async (images, onLoad) => {
		if (typeof images === 'object'){
			images = Object.entries(images).map(([name, src]) => {
				return {name, src}
			});
		}

		return new Promise(resolve => {
			Promise.all(images.map((src, i) => {
				return this.loadImage(src, onLoad, i);
			})).then((loadedImages) => {
				let r={};
				loadedImages.forEach((curImage) => {
					r[curImage.name] = curImage;
				})
				resolve(r);
			});
		})
	}


	static loadImage = async (src, onLoad, i=0) => {
		return new Promise((resolve, reject)=>{
			if(typeof src === 'string') src = {	name:'image'+i, src };
			let img = new Image();
			src.img = img;
			img.onload = () => {
				onLoad?.(src);
				resolve(src);
			}
			img.onerror = img.onabort = reject;
			img.src = src.src;
		})
	}

	// static loadImage = async (image) => {
	// 	if (Array.isArray(image)){
	// 		return Promise.all(image.map((src,i)=>{
	// 			return this.loadImage(src);
	// 		}));
	// 	}

	// 	if (typeof image === 'object' && !image.src){
	// 		return Promise.all(
	// 			Object.keys(image).map(i => {
	// 				return this.loadImage(image[i]);
	// 			}
	// 		))
	// 	}

	// 	console.log(image.src);

	// 	new Promise((resolve, reject) => {
	// 		let img = new Image();
	// 		image.img = img;
	// 		img.onload = e => resolve(image);
	// 		img.onerror = img.onabort = e => reject(e);
	// 		img.src = image.src;
	// 	});
	// }

	
	static wait = async (sec=3) => {
		await new Promise(r => setTimeout(r, sec * 1000));	//wait n sec
	}
	

	static getDateTime(date, format='dd.mm.yyyy HH:MM:ss'){
		let now = date || new Date();
		let d = DateFormat(now, format);
		return d;
	}


	static getPlayTime(){
		return secondsToTime(performance.now() / 1000);
	}


	// ------------------------------------------------------------------------ get node type
	// none | array | boolean | number | string | date | object
	static getType(value){
		if (value === undefined || value === null) return 'none';
		let t = typeof value;
		if (t === 'object') return Array.isArray(value)? 'array' : t;
		if (value === 'true' || value === 'false') return 'boolean';
		return t;
	}


	// ------------------------------------------------------------------------ fullScreenshot
	// https://hackernoon.com/how-to-take-screenshots-in-the-browser-using-javascript-l92k3xq7
	//
	static async getScreenshot(callback, imageFormat='image/jpeg') {
		console.log('capture webrtc-screen');

		let stream;

		try {
			const desktopCapturer = window.require?.('electron').desktopCapturer;
			const win = window.require?.('electron').remote?.getCurrentWindow();

			if (desktopCapturer && win){	//electron native screen capture
				let title = win.getTitle();
				let size = win.getSize();
				let sources = await desktopCapturer.getSources({ types: ['window', 'screen'] });
				let source = sources.find(s => s.name === title);	//find the application window
				if (!source){
					console.error('no media source found:', title, sources)
					return null
				}
				
				console.log('native window-capture:', title, size[0], size[1], source);

				stream = await navigator.mediaDevices.getUserMedia({
					audio: false,
					video: {
						mandatory: {
							chromeMediaSource: 'desktop',
							chromeMediaSourceId: source.id,
							minWidth: size[0],
							maxWidth: size[0],
							minHeight: size[1],
							maxHeight: size[1]
						}
					}
				});
		
			}else{		//	browser-window screen capture
				console.log('browser window-capture:', window.innerWidth, window.innerHeight);
				stream = await navigator.mediaDevices.getUserMedia({video:true});

			}

			const video = document.createElement("video");
			video.srcObject = stream;
			await new Promise(e => video.onloadedmetadata = e);

			console.log('video-data:', video.videoWidth, video.videoHeight);
			await video.play();

			const canvas = document.createElement("canvas");
			canvas.width = video.videoWidth;
			canvas.height = video.videoHeight;
			const context = canvas.getContext("2d");
			context.drawImage(video, 0, 0);
			const frame = canvas.toDataURL(imageFormat, 0.9);
			// window.location.href = frame;

			video.remove();							// Remove hidden video tag
			try {
				stream.getTracks()[0].stop();		// Destroy connect to stream
			} catch (e) {}
		
			callback?.(frame);
			return frame;

		} catch (err) {
			console.error("Error: " + err);
			callback?.(null);
		}
	}


	//----------------------------------------------------------------------------- loadConfig
	static async loadConfig(url, options){
		url = url || './config.json';

		let config = await this.fetch(url);
		if (!config){
			if (typeof options === 'function') options(null);		//callback function
			return null;
		}

		// ReferenceError: process is not defined (!if not a node environment)
		try {
			if (config.environment && config.environment[process?.env.NODE_ENV]){
				ObjectUtil.append(config, config.environment[process?.env.NODE_ENV]);
			}
		} catch (error) {
			console.error('not a node environment!')
		}

		config = ObjectUtil.replaceNodes(config)	//replace all placeholders from json data

		if (config.device){
			let dev = this.getDevice();
			if (config.device[dev]){
				ObjectUtil.append(config, config.device[dev]);
			}
		}
		if (config.runtime){
			let rt = window.require? 'node' : 'web';
			if (config.runtime[rt]){
				ObjectUtil.append(config, config.runtime[rt]);
			}
		}

		// ---merge optional settings
		if (options && options.merge){
			for (let e in options.merge){
				if (config[e] && config[e][options.merge[e]]){
					ObjectUtil.append(config, config[e][options.merge[e]]);
				}
			}
		}
		
		console.log('🎬','config', config);
		global.config = config;

		if (typeof options === 'function') options(config);		//callback function
		return config;
	}


	//----------------------------------------------------------------------------- cmd
	//https://nodejs.org/api/child_process.html#child_process_child_process_exec_command_options_callback
	// Computer\HKEY_LOCAL_MACHINE\SOFTWARE\WOW6432Node\TeamViewer
	// cmd('file', callback, {cmd:'folder'})
	static async cmd(command, callback, opt){
		if (!exec) return null;			//not a node environment!

		let c;

		switch (command){
		case 'teamviewer': c = 'reg query HKLM\\SOFTWARE\\WOW6432Node\\TeamViewer /v ClientID || reg query HKLM\\SOFTWARE\\TeamViewer /v ClientID';
			break;
		// case 'teamviewer': c = 'reg query HKLM\\SOFTWARE\\WOW6432Node\\TeamViewer /v ClientID'; break;
		// case 'teamviewer_2': c = 'reg query HKLM\\SOFTWARE\\TeamViewer /v ClientID'; break;
		case 'serialnumber': c = 'wmic bios get serialnumber'; break;
		case 'computername': c = 'hostname'; break;
		default: c = command;
		}

		return new Promise((resolve, reject) => {
			try {
				exec(c, opt, (error, stdout, stderr) => {
					if (!stdout){
						callback?.(null);
						// console.error(error);
						return resolve('');	//error
					}
		
					let result = stdout.replace(/\r?\n|\r/g, '');
					let a;
					switch (command){
					case 'teamviewer':
					case 'teamviewer_2':
						a = result.split(' ');
						result = parseInt(a[a.length-1]);
						result = result? String(result) : ''
						break;
					case 'serialnumber':
						a = result.split('      ');
						result = a[a.length-1].trim();
						break;
					// case 'computername': return result;
					default:
					}
	
					callback?.(result);
					return resolve(result);
				})
			} catch (error) {
				console.error('error on running script', c);
				console.error(error);
				callback?.(null);
				return resolve('');
			}
		})
	}

	
	//----------------------------------------------------------------------------- getRuntime
	static isMobile(device){	//https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
		let nu = navigator.userAgent;
		switch(device){
			case 'android'		: return nu.match(/Android/i);
			case 'blackberry'	: return nu.match(/BlackBerry/i);
			case 'ios'			: return nu.match(/iPhone|iPad|iPod/i);
			case 'opera'		: return nu.match(/Opera Mini/i);
			case 'windows'		: return nu.match(/IEMobile/i);
			case undefined:
			case 'any'			: return (
				this.isMobile('android') ||
				this.isMobile('blackberry') ||
				this.isMobile('ios') ||
				this.isMobile('opera') ||
				this.isMobile('windows')) || false;
			default:
		}
	}
	
	
	//----------------------------------------------------------------------------- getRuntime
	static isOS(os){
		switch(os){
			case 'windows'		: return navigator.userAgent.match(/Windows/i);
			case 'linux'		: return navigator.userAgent.match(/Linux/i);
			// case 'ios'			: return;
		default:
		}
	}


	//----------------------------------------------------------------------------- logSystem
	static logSystem = () => {
		const log = (...val) => {	//colorized log output
			console.log('%c' + val.join(' '), 'color:#cf5');
		}

		let sys = this.getSystem()

		log('=================================================');
		log('agent            :', sys.agent);
		log('location         :', sys.location);
		// log('dirname          :', __dirname);
		// log('filename         :', __filename);
		log('environment      :', sys.environment);
		log('os               :', sys.os);
		if (os?.version){
			// log('release          :', sys.release);
			// log('platform         :', sys.platform);
			log('computername     :', sys.computername);
			log('username         :', sys.username);
		}
		log('browser          :', sys.browser);
		log('device           :', sys.device);
		log('runtime          :', sys.runtime);

		if (window.process){
			log('node version     :', sys.version.node);
			log('chrome version   :', sys.version.chrome);
			log('electron version :', sys.version.electron);
		}
		
		log('react version    :', sys.version.react);
		log('=================================================');

		global.system = sys;
		global.isDev = sys.environment === 'development'	//short-key für development mode

		console.log('location:', window.location)
		console.log('navigator:', window.navigator)
	
		return sys;
	}


	//----------------------------------------------------------------------------- getSystem
	static getSystem = () => {
		let sys = {}
		sys.agent		= navigator.userAgent
		sys.location	= window.location.href
		sys.environment	= process.env.NODE_ENV		//development | production

		if (os){
			sys.os = os.version?.() || this.getOs()

			//hotfix for windows 11 version
			if (sys.os.startsWith('Windows') && sys.release){
				let ver = Number(sys.release.split('.').pop())
				if (ver >= 22000) sys.os = sys.os.replace('10', '11')
			}

			// sys.release = os.release?.()
			// sys.platform = os.platform?.() + ' ' + os.arch?.()
			sys.os += ', ' + os.release?.() + ', ' + os.platform?.() + ' ' + os.arch?.()

			sys.computername = os.hostname?.()
			sys.username = os.userInfo?.().username
		}else{
			sys.os = this.getOs()
		}
		
		sys.browser		= this.getBrowser()
		sys.device		= this.getDevice()
		sys.runtime		= this.getRuntime()
		sys.version	= {
			react		: React.version,
		}

		if (window.process){
			let v = window.process.versions;
			sys.version.node = v.node;
			sys.version.chrome = v.chrome;
			sys.version.electron = v.electron;
		}

		return sys
	}


	//----------------------------------------------------------------------------- getRuntime
	static getRuntime = () => {
		// not working anymore!!!
		// return (typeof process !== 'undefined') && (process?.release?.name === 'node')? 'node' : 'web';
		return window.require? 'node' : 'web';
	}


	//----------------------------------------------------------------------------- getOs
	static getOs = () => {
		let ua = window.navigator.userAgent
		if (ua.indexOf("Win") !== -1) return "Windows";
		if (ua.indexOf("Mac") !== -1) return "MacOS";
		if (ua.indexOf("X11") !== -1) return "UNIX";
		if (ua.indexOf("Linux") !== -1) return "Linux";
		return 'unknown'
	}


	//----------------------------------------------------------------------------- getBrowser
	static getBrowser = () => {		//https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator
		var sBrowser, sUsrAg = navigator.userAgent;
		// The order matters here, and this may report false positives for unlisted browsers.
		if (sUsrAg.indexOf("Firefox") > -1) {
			sBrowser = "Mozilla Firefox";
		// "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
		} else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
			sBrowser = "Samsung Internet";
		// "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
		} else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
			sBrowser = "Opera";
		// "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
		} else if (sUsrAg.indexOf("Trident") > -1) {
			sBrowser = "Microsoft Internet Explorer";
		// "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
		} else if (sUsrAg.indexOf("Edge") > -1) {
			sBrowser = "Microsoft Edge";
		// "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
		} else if (sUsrAg.indexOf("Chrome") > -1) {
			sBrowser = "Google Chrome or Chromium";
		// "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
		} else if (sUsrAg.indexOf("Safari") > -1) {
			sBrowser = "Apple Safari";
		// "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
		} else {
			sBrowser = "unknown";
		}

		// console.log('browser:', sBrowser);
		return sBrowser;
	}


	//----------------------------------------------------------------------------- getDevice
	static getDevice = () => {		//https://dev.to/itsabdessalam/detect-current-device-type-with-javascript-490j
		const ua = navigator.userAgent;
		if (ua.includes('Electron')) {
			return "desktop";
		}
		// if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {	//macintosh can also be a mac
		if (/(tablet|ipad|macintosh|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
			return "tablet";		//macbook is like a tablet
		}
		if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
			return "mobile";
		}
		return "browser";
	}


	//----------------------------------------------------------------------------- download
	// html-download to local file
	static download = (name, data) => {
		var a = document.createElement('a');
		var file = new Blob([JSON.stringify(data)]);
		a.href = URL.createObjectURL(file);
		a.download = name;
		a.click();
	}

	
	//----------------------------------------------------------------------------- getTimeString
	static getTimeString = (date) => {
		date = date || new Date();
		return DateFormat(date, 'yyyy-mm-dd HH:MM:ss');
		// return date.toLocaleDateString('fr-CA') + ' ' + date.toLocaleTimeString();		//e.g.: 2020-11-15 10:23:45
	}


	//----------------------------------------------------------------------------- log
	// e.g: await sleep(1000);		//wait 1 sec.
	static sleep = (ms = 0) => {
		return new Promise(r => setTimeout(r, ms));
	}


	//----------------------------------------------------------------------------- log
	static logMessage = '';
	static logElement;

	static log = message => {
		let el = this.logElement;
		if (!message){
			if (el) el.remove();
			return this.logElement = null;
		}

		if (!el){
			let root = document.getElementById('root');
			el = document.createElement('div');
			el.setAttribute('class', 'sys-modal sys-log');
			el.onclick = e => this.log();
			root.appendChild(el);
			this.logElement = el;
		}

		el.innerHTML = '<div class="sys-log-text">' + message + '</div>';
		// el.innerHTML = message;
	}


	//----------------------------------------------------------------------------- info
	// pos: top | bottom
	static sysInfo

	static info = (message, pos) => {
		let el = this.sysInfo

		if (!message){
			el?.remove()
			return this.sysInfo = null
		}

		if (!el){
			let root = document.getElementById('root');
			this.sysInfo = el = document.createElement('div');
			el.setAttribute('class', 'sys-info' + (pos? ' ' + pos : ''));
			el.onclick = e => this.info();
			root.appendChild(el);
		}

		let t = typeof message
		if (t === 'string'){
			el.innerHTML = message;
			
		}else if (t === 'object'){
			let msg = ''
			for (let e in message){
				msg += '<div>' + e + ': ' + message[e] + '</div>'
				el.innerHTML = msg;
			}
		}
	}

	//----------------------------------------------------------------------------- status
	static status = (message) => {
		this.info(message, 'bottom')
	}


	//----------------------------------------------------------------------------- alert
	// sample:
	// Sys.alert('Your Message', false, ['Abbrechen', 'OK'], {onSelect:e => {
	// 	console.log('select', e)
	// }})
	//
	static alertElement;
	static alertTimeout;

	static alert = (message, spinner=false, button='OK', props) => {
		let autoClose = props?.autoClose ?? true
		let el = this.alertElement;
		if (!!this.alertTimeout) clearTimeout(this.alertTimeout);

		if (!message && !spinner){
			if (el) el.remove();
			return this.alertElement = null;
		}

		if (!el){
			let root = document.getElementById('root');
			el = document.createElement('div');
			el.className = 'sys-modal sys-alert';
			root.appendChild(el);
			this.alertElement = el;
		}else{
			while (el.lastElementChild) el.removeChild(el.lastElementChild);
		}

		let m = document.createElement('div');
		m.className = 'sys-alert-text';
		m.innerHTML = message;
		el.appendChild(m);

		console.info('[' + message + ']')

		if (spinner){
			let s = document.createElement('div');
			s.innerHTML = `<svg class='sys-spinner' >
				<circle cx='20' cy='20' r='16' stroke='white' opacity='0.10' />
			 	<circle cx='20' cy='20' r='16' stroke='white' opacity='0.5' />
			</svg>`
			el.appendChild(s);
		}

		if (button){
			if (Array.isArray(button)){
				let btn = document.createElement('div');
				btn.className = 'sys-buttons';
				el.appendChild(btn);

				button.forEach(e => {
					let b = document.createElement('div');
					b.className = 'sys-button';
					b.innerHTML = e;
					b.addEventListener('click', () => {
						props?.onSelect?.(e)
						if (autoClose) Sys.alert()
					})
					btn.appendChild(b);
				})
			}else{
				let b = document.createElement('div');
				b.className = 'sys-button';
				b.innerHTML = button;
				b.addEventListener('click', e => {
					props?.onSelect?.(e)
					if (autoClose) Sys.alert()
				})
				el.appendChild(b);
			}
		}

		if (props && props.onTimeout){
			this.alertTimeout = setTimeout(props.onTimeout, props.timeout || 5000);
		}
		return el;
	}


	//----------------------------------------------------------------------------- getUrlVars
	static getUrlVars = function(){
		if (urlVars) return urlVars;

		urlVars = {};
		window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => {urlVars[key] = value});
		return urlVars;
	}


	//----------------------------------------------------------------------------- getHtml
	static async getHtml(url, callback, search){
		let html = await ( await fetch(url) ).text();
		var doc = new DOMParser().parseFromString(html, 'text/html');

		if (search){
			let type = search.substring(0, 1);
			let list;
			if (type === '.') list = doc.getElementsByClassName(search.substring(1));
			else if (type === '#') list = doc.getElementById(search.substring(1));
			else list = doc.getElementsByTagName(search);
			return (Array.from(list));
		}else{
			if (callback) callback(doc);
			return doc;
		}
	}


	//----------------------------------------------------------------------------- fetch
	// check: https://dmitripavlutin.com/timeout-fetch-request/?utm_source=pocket_mylist
	// e.g: Sys.fetch(url, {method:'PUT', body:JSON.stringify(data)})
	// TODO: optional load first from localStore
	//
	/*
	let data = await (await (fetch('C:/JTClient/sysinfo.cfg')
			.then(res => {return res.json()})
			.catch(err => {
				console.log('error on loading: C:/JTClient/sysinfo.cfg');
			})
		))
	*/
	static async fetch(url, options={}, callback, store='', onlineFirst=true){
		//---fetch used with timeout handler
		const timeout = options?.timeout || 10000	//default = 10 sec. timeout
		const controller = new AbortController()
		const timeoutId = setTimeout(() => controller.abort(), timeout);

		if (options){
			store = options.store || store
			callback = options.callback || callback
			onlineFirst = options.onlineFirst || onlineFirst
			options.signal = controller.signal   
		}

if (typeof callback === 'object' && options === null) options = callback	//workaround for old version

		if (store === true) store = url;	//take url as store-key

		if (store && !onlineFirst){			//try to take local store data first
			let data = await Sys.storageProvider.getItem(store);
			if (data){
				console.log('data from localStore:', store);
				if (callback && typeof callback === 'function')	callback(data);
				return data;
			}
		}

		let res = await fetch(url, options).catch(err => {
			console.error('fetch error!', err);
		});

		clearTimeout(timeoutId);	//clear timeoutId

		let data;

//<br/><b>Deprecated</b>:  Symfony\Component\HttpFoundation\File\UploadedFile::__construct(): Implicitly marking parameter $mimeType as nullable is deprecated, the explicit nullable type must be used instead in <b>/var/www/knapp-dev/bl/vendor/symfony/http-foundation/File/UploadedFile.php</b> on line <b>63</b><br/><br/><b>Deprecated</b>:  Symfony\Component\HttpFoundation\File\UploadedFile::__construct(): Implicitly marking parameter $error as nullable is deprecated, the explicit nullable type must be used instead in <b>/var/www/knapp-dev/bl/vendor/symfony/http-foundation/File/UploadedFile.php</b> on line <b>63</b><br/><br/><b>Deprecated</b>:  Symfony\Component\HttpFoundation\File\UploadedFile::move(): Implicitly marking parameter $name as nullable is deprecated, the explicit nullable type must be used instead in <b>/var/www/knapp-dev/bl/vendor/symfony/http-foundation/File/UploadedFile.php</b> on line <b>175</b><br/><br/><b>Deprecated</b>:  Symfony\Component\HttpFoundation\File\File::move(): Implicitly marking parameter $name as nullable is deprecated, the explicit nullable type must be used instead in <b>/var/www/knapp-dev/bl/vendor/symfony/http-foundation/File/File.php</b> on line <b>91</b><br/><br/><b>Deprecated</b>:  Symfony\Component\HttpFoundation\File\File::getTargetFile(): Implicitly marking parameter $name as nullable is deprecated, the explicit nullable type must be used instead in <b>/var/www/knapp-dev/bl/vendor/symfony/http-foundation/File/File.php</b> on line <b>124</b><br/>{
//    "filename": "3eaa9386-15aa-4803-b0ef-9295ac62bf69.jpg",
//    "url": "https:\/\/knapp-dev.jumptoday.group\/bl\/public\/uploads\/3eaa9386-15aa-4803-b0ef-9295ac62bf69.jpg"
//}
		if (res?.ok){
			// res.headers.forEach((value, name) => console.log('> ' + name + ' : ' + value))
			let type = res.headers.get('content-type');
			if (type.includes('application/json')){
				data = await res.json().catch(err => {
					console.error('json error!', err);
				})
			}else{
				data = await res.text().catch(err => {
					console.error('json error!', err);
				})
			}
		}else{
			console.log('error on loading data!', url)
		}

		if (store){
			if (data){	//update new loaded data to localStore
				console.log('save to localStore:', store);
				try {
					// await Sys.storageProvider.setItem(store, JSON.stringify(data));
					await Sys.storageProvider.setItem(store, data);
				} catch (error) {
					console.error('error on setting item to localStore!', store, error);
				}
			}else{		//fallback: load data from localStore
				data = await Sys.storageProvider.getItem(store);
				if (data){
					console.log('data from localStore:', store);
					// data = JSON.parse(data);
				}
			}
		}

		if (callback && typeof callback === 'function')	callback(data);
		return data;
	}


	//----------------------------------------------------------------------------- setFullscreen
	static setFullscreen = async (on, elem=document.documentElement) => {
		let isOn = document.fullscreenElement !== null;

		if (on !== undefined && ((on && isOn) || (!on && !isOn))) return;

		try{
			if (isOn){
				if (document.exitFullscreen) await document.exitFullscreen();
				else if (document.mozCancelFullScreen) await document.mozCancelFullScreen();
				else if (document.webkitExitFullscreen) await document.webkitExitFullscreen();
				else if (document.msExitFullscreen) await document.msExitFullscreen();
				else return
	
				this.isFullscreen = false;
	
			}else{
				if (elem.requestFullscreen)	await elem.requestFullscreen();
				else if (elem.mozRequestFullScreen) await elem.mozRequestFullScreen();		// Firefox
				else if (elem.webkitRequestFullscreen) await elem.webkitRequestFullscreen();	// Chrome, Safari & Opera
				else if (elem.msRequestFullscreen) await elem.msRequestFullscreen();			// IE/Edge
				else return
	
				this.isFullscreen = true;
			}
		}catch(error){
			console.error('fullscreen error!', error);
		}
	}


	//----------------------------------------------------------------------------- fullscreen
	static isFullscreen = false;

	static switchFullscreen = async (elem=document.documentElement) => {
		// let elem = document.documentElement;
		let isOn = document.fullscreenElement !== null;

		// let on = !isOn;
		// if (on !== undefined && ((on && isOn) || (!on && !isOn))) return;
		console.log('---switch fullscreen:', isOn? 'off' : 'on', elem);

		if (isOn){
			await this.setFullscreen(false)

		}else{
			await this.setFullscreen(true, elem)
		}
	}

		/*
		// https://stackoverflow.com/questions/1125084/how-to-make-the-window-full-screen-with-javascript-stretching-all-over-the-scre/7525760#7525760
		function requestFullScreen(element) {
			// Supports most browsers and their versions.
			var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

			if (requestMethod) { // Native full screen.
				requestMethod.call(element);
			} else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
				var wscript = new ActiveXObject("WScript.Shell");
				if (wscript !== null) {
					wscript.SendKeys("{F11}");
				}
			}
		}
		var elem = document.body; // Make the body go full screen.
		requestFullScreen(elem);
		*/
}